var img = "data:image/svg+xml,%3csvg width='21' height='18' viewBox='0 0 21 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M4.5 8L1 8C1 12.9706 5.25329 17 10.5 17C15.7467 17 20 12.9706 20 8L16.5 8' stroke='white' stroke-width='1.5'/%3e %3ccircle cx='10.5' cy='6.5' r='5.75' stroke='white' stroke-width='1.5'/%3e%3c/svg%3e";
  var LoyaltyOutlined = img;

export { LoyaltyOutlined as default };
